module.exports = __webpack_public_path__ + "static/index/assets/img/3.4ee023f1.png";